import { Field } from 'formik';
import { SttDatePicker } from '@stt-componentes/core';
import { DATA_EXAME_ATE } from '../fieldNames';

const DataFinalExame = ({ strings }) => {

    return (
         <Field name={DATA_EXAME_ATE}>
            {({
                field: { name, value, },
                form: { setFieldValue, setFieldError, setFieldTouched },
                meta
            }) => {
                let erroAtual = meta.error;
                return (
                    <SttDatePicker
                        label={strings.dataFinalExame}
                        inputprops={{
                            name: name
                        }}
                            disableFuture
                            maxDate={new Date()}
                            error={meta.touched && meta.error ? true : false}
                            onError={error => {
                                if (error && error !== erroAtual) {
                                   setFieldError(DATA_EXAME_ATE, error);
                                }
                            }}
                            value={value}
                            onBlur={() => {
                                setFieldTouched(DATA_EXAME_ATE, true);
                            }}
                            helperText={meta.touched && meta.error ? meta.error : undefined}
                            onChange={date => setFieldValue(DATA_EXAME_ATE, date, true)}
                            onClose={() => setFieldTouched(DATA_EXAME_ATE, true)}
                        />
                    );
                }}
            </Field>
        );
    };
    
export default DataFinalExame;